import React, { useEffect, useState } from 'react'
import PokeGuide from './PokeGuide'
import SearchPresentation from './SearchPresentation'
import ThemeContext from '../theme-context'
import Header from './Header'
import {
    Switch,
    Route,
    useLocation,
    useParams,
    useRouteMatch
  } from "react-router-dom";

  import {useSelector, useDispatch} from 'react-redux'
  import { toggleMedia } from '../store/mediaSlice'
//   import {
//       toMovie,
//       toShow,
//       isFilm
//   } from '../store/reducers'


function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function Guide() {
    const [isLoading, setIsLoading] = useState(false);
    const [theme, setTheme] = useState("primary");
    const [pokemon, setPokemon] = useState({})
    const [language, setLanguage] = useState("ja");
    const [searchResults, setSearchResults] = useState([]);
    let location = useLocation();
    let query = useQuery();
    let { id } = useParams();
    let match = useRouteMatch();

    const media = useSelector(state => state.media);
    
    const dispatch = useDispatch()

    useEffect(() => {
        getPokemon(1)
    },[])

    const changeTheme = () => {
        setTheme((theme) => {
            return theme === "primary" ? "secondary" : "primary"
        })
    }

    const getPokemon = (number) => {
        fetch(`https://pokeapi.co/api/v2/pokemon/${number}`)
        .then(res => res.json())
        .then((result) => {
            setPokemon(result);
        }
        ).catch(function(){
        })
    }

    const changePokemon = () => {
        const num = Math.floor(Math.random() * 895) + 1;
        getPokemon(num)
    }

    const themeMemo = React.useMemo(() => ({
        theme,
        changeTheme
    }))

    return (
        <ThemeContext.Provider value={themeMemo}>
            <Header />
            <Switch>
                <Route exact path="/">
                    <PokeGuide getPokemon={getPokemon} pokemon={pokemon} handleClick={changePokemon} />
                </Route>
            </Switch>
        </ThemeContext.Provider>
    )
}
